import { z } from 'zod';

import { EliteLoanExtensionAgreementInput } from '../events/CreateLoanExtensionAgreementEvent';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateLoanExtensionAgreementSideEffectContext = BaseLoanIdSideEffect.extend({
  input: EliteLoanExtensionAgreementInput,
});
export const GenerateLoanExtensionAgreementSideEffect = GenerateLoanExtensionAgreementSideEffectContext.extend({
  type: z.literal('generateLoanExtensionAgreement'),
});
export type GenerateLoanExtensionAgreementSideEffect = z.infer<typeof GenerateLoanExtensionAgreementSideEffect>;
